const openFileDialog = () => {
  return new Promise((resolve, reject) => {
    const fileInput = document.createElement("input");
    fileInput.type = "file";
    fileInput.accept = ".pdf,application/pdf";
    fileInput.multiple = true;

    fileInput.addEventListener("change", (event) => {
      const files = event.target.files;

      if (files.length > 0) {
        const nonPDFFiles = Array.from(files).filter(
          (file) =>
            file.type !== "application/pdf" &&
            !file.name.toLowerCase().endsWith(".pdf")
        );

        if (nonPDFFiles.length > 0) {
          alert("Only PDF files are allowed");
          resolve([]);
        } else {
          resolve(files);
        }
      } else {
        resolve([]);
      }
    });

    fileInput.click();
  });
};

export default openFileDialog;
